import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

export interface ClipboardData {
  invitationLink: string;
}

@Component({
  selector: 'izy-copy-to-clipboard',
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './copy-to-clipboard.component.html',
  styleUrl: './copy-to-clipboard.component.scss',
})
export class CopyToClipboardComponent {
  constructor(
    public dialogRef: MatDialogRef<CopyToClipboardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ClipboardData
  ) {}

  copyToClipboard(): void {
    navigator.clipboard
      .writeText(this.data.invitationLink)
      .then(() => {
        // You could show a small confirmation here or rely on the parent
        this.dialogRef.close(true); // Close with success
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
        this.dialogRef.close(false); // Close with failure
      });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
